import { Link } from "react-router-dom";
import Layout from "../cponents/layout";
import { useEffect, useState } from "react";
import BaseEndpoint from "../endpoints/baseEndpoint";

export default function Landing() {
    const [data, setData] = useState(null);

    useEffect(() => {
        BaseEndpoint.instance().get('/web-instruction/home').then((res) => {
            if (res.status === 200) {
                setData(res.data);
            }
        });
    }, []);

    return (
        <Layout>
            <div className="container py-5 row mx-auto align-items-center">
                <div className="col-md-6 py-5">
                    <img src="/logo/pl-smaller.png" alt="" className="img-fluid w-100" style={{ maxWidth: "300px" }} />
                    <h2>{data?.title || 'Develop your potential and reach your dream'}</h2>
                    <p dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
                    <Link to="/login" className="mt-3 px-4 py-3 btn btn-primary rounded-pill text-white">Sudah punya kode</Link>
                </div>
                <div className="col-md-6">
                    <img src="/assets/images/hero-overview.svg" alt="" className="img-fluid w-100" />
                </div>
            </div>
        </Layout>
    )
}